import { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import EditDepartment from "./EditDepartments";
import { useDepartments, updateDepartment } from "services/departmentService";
import { toast } from "react-toastify";
import { Loader } from "@progress/kendo-react-indicators";

const DepartmentList = () => {
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { data: departments, loading } = useDepartments();

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    try {
      const data = {
        code: event.code,
        name: event.name,
        active: event.active,
      };

      const result = await updateDepartment(event.departmentID, data);

      if (result.success) {
        toast.success("Department updated successfully");
        setOpenForm(false);
      } else {
        toast.error("Failed to update department");
      }
    } catch (error) {
      toast.error("Error updating department");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <Loader type="pulsing" size="large" />
      </div>
    );
  }

  return (
    <div className="settings-grid-wrapper">
      <div className="settings-grid">
        <Grid
          data={departments}
          style={{ width: "max-content", maxWidth: "100%" }}
        >
          <Column field="name" title=" " cell={SignatureCell} width="80px" />
          <Column field="code" title="Code" width="100px" />
          <Column field="name" title="Name" width="180px" />
          <Column
            cell={ActiveCell}
            title="Active"
            field="active"
            width="50px"
          />
          <Column title="Edit" cell={MyEditCommandCell} width="40px" />
        </Grid>

        {openForm && (
          <EditDepartment
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            item={editItem}
            isSubmitting={isSubmitting}
          />
        )}
      </div>
    </div>
  );
};

export default DepartmentList;
